import React from "react";

export default function Nav() {
  return (
    <nav>
      <ion-icon name="earth-outline"></ion-icon> MyTravelJournal
    </nav>
  );
}